var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFewNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 42,
    viewBox: "0 0 57 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4991,
    cy: 12.9557,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.3184,
    cy: 18.1368,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4991,
    cy: 23.318,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.6827,
    cy: 18.1368,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.8643,
    cy: 12.9557,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.045,
    cy: 18.1368,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.2267,
    cy: 12.9557,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.4093,
    cy: 18.1368,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.2267,
    cy: 23.318,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.8643,
    cy: 23.318,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4991,
    cy: 23.318,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.3184,
    cy: 2.59091,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1368,
    cy: 2.59091,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 2.59091,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 7.77304,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1368,
    cy: 7.77304,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77353,
    cy: 7.77304,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.59091,
    cy: 12.9557,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77353,
    cy: 12.9557,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 12.9557,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.59091,
    cy: 18.1368,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77353,
    cy: 18.1368,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77353,
    cy: 23.318,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77353,
    cy: 28.4991,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77353,
    cy: 33.6827,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 18.1368,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.59091,
    cy: 23.318,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 23.318,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.59091,
    cy: 28.4991,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 28.4991,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1368,
    cy: 28.4991,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 33.6827,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1368,
    cy: 33.6827,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.3184,
    cy: 33.6827,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4991,
    cy: 33.6827,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.6827,
    cy: 33.6827,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9552,
    cy: 38.8639,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1368,
    cy: 38.8639,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.3184,
    cy: 38.8639,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4991,
    cy: 38.8639,
    rx: 2.59091,
    ry: 2.59091,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewNight);
export default __webpack_public_path__ + "static/media/few-night.9c22f5ab2183ff518189735c3785d4a6.svg";
export { ForwardRef as ReactComponent };